




import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Paper,
  useMediaQuery,
  FormControl,
  InputLabel,
  Select,
  MenuItem as MuiMenuItem,
  Chip,Button
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DataGrid } from "@mui/x-data-grid";
import { useStyles } from "../../assets/styles/Theme";
import { SUPPLIER_TYPE_MAP } from "../../utils/sys/Constants";
import DownloadIcon from '@mui/icons-material/Download';

function ViewDataGridProduct({
  columns,
  rows,
  menuItems,
  tabletitle,
  gridid,
  displayActions = true,
  onSelectionChange,
   displaycheckbox = false,
    onActionClick,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [density, setDensity] = useState("standard");
  const theme = useTheme();
  const styles = useStyles(theme);
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedRows, setSelectedRows] = useState([]);
  const statusColorMap = {
    Submitted: "primary",
    Returned: "warning",
    Approved: "success",
    Rejected: "error",
  };

  const handleOpenUserMenu = (event, row) => {
    setAnchorEl({ anchor: event.currentTarget, row });
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (menuItem, row) => {
    menuItem.onClick(row[gridid]);
    handleCloseUserMenu();
  };

  if (!columns || !rows || !Array.isArray(columns) || !Array.isArray(rows)) {
    console.error("Invalid columns or rows");
    return null;
  }

  // Convert table titles to title case
  const titleCase = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Add action column if displayActions is true
const actionColumn = displayActions
  ? [
      {
        field: "actions",
        headerName: "Actions",
        width: 100,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => (
          <Button
            variant="contained"
            size="small"
            color="primary"
            Capitalize=""
             sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
           onClick={() => {
              if (onActionClick) {
                onActionClick(params.row);
              }
            }}
          >
            Select
          </Button>
        ),
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        pinned: "right",
        cellClassName: "actions-column-cell",
        headerClassName: "actions-column-header",
      },
    ]
  : [];

 const dataGridColumns = columns.map((column) => ({
  ...column,
  headerName: titleCase(column.headerName),
  headerAlign: column.textAlign ? column.textAlign.toLowerCase() : "left",
  align: column.textAlign ? column.textAlign.toLowerCase() : "left",
  renderCell:
    column.field === "STATUS"
      ? (params) => {
          const status = params.value;
          const color = statusColorMap[status] || "default";
          return <Chip label={status} color={color} size="small" />;
        }
     
      : column.field === "docpathjson"
      ? (params) => {
          const fileUrl = params.value;
          if (!fileUrl) return null;
          return (
            <IconButton
              component="a"
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              aria-label="Download"
            >
              <DownloadIcon />
            </IconButton>
          );
        }
      : undefined,
}));
  return (
    <>
      <Paper sx={styles.VDG_paper}>
        {/* <Box sx={styles.VDG_box}> */}

        {/* Row Density Dropdown */}

        {}
        <Box sx={{ height: 280, width: "100%" }}>
          <DataGrid
            columns={[...dataGridColumns, ...actionColumn]}
            rows={rows}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 100]}
          checkboxSelection ={displaycheckbox}
            disableSelectionOnClick
            density={density}
            // onRowSelectionModelChange={(newSelection) => {
            //   setSelectedRows(newSelection);
            // }}
            onRowSelectionModelChange={(newSelection) => {
              setSelectedRows(newSelection);
              onSelectionChange?.(newSelection); // ← propagate up
            }}
            rowSelectionModel={selectedRows}
            getRowId={(row) => row.id}
            components={{
              ColumnMenu: null,
            }}
            sx={{
              fontSize: theme.typography.body_s,
              p: 1,
              overflowX: "auto",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.paper,
                textTransform: "capitalize",
              },
              // "& .MuiDataGrid-cell": {
              //   display: "flex",
              //   alignItems: "center",
              //   justifyContent: "center",
              // },
              "& .MuiDataGrid-columnHeaderTitle": {
                textAlign: "center",
                width: "100%",
                textTransform: "capitalize",
                fontSize: theme.typography.subtitle_m,
                fontWeight: 600,
              },
              "& .MuiDataGrid-columnHeader--pinnedRight": {
                backgroundColor: theme.palette.background.paper,
              },
              "& .MuiDataGrid-cell--pinnedRight": {
                backgroundColor: theme.palette.background.paper,
              },

              "& .MuiDataGrid-container--top  [role=row]": {
                backgroundColor: theme.palette.background.bgShade_1,
                color: theme.palette.text.secondary,

                // boxShadow: 1,
              },
              "& .actions-column-cell": {
                position: "sticky",
                right: 0,
                backgroundColor: theme.palette.background.paper,
                zIndex: 1,
                // borderLeft: `1px solid ${theme.palette.divider}`,
              },
              "& .actions-column-header": {
                position: "sticky",
                right: 0,
                backgroundColor: theme.palette.background.bgShade_1,
                zIndex: 2,
                // borderLeft: `1px solid ${theme.palette.divider}`,
              },
            }}
          />
        </Box>
       <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
 
</Box>
      </Paper>
    </>
  );
}

ViewDataGridProduct.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node,
    })
  ).isRequired,
  tabletitle: PropTypes.string.isRequired,
  gridid: PropTypes.string.isRequired,
};

ViewDataGridProduct  .defaultProps = {
  columns: [],
  rows: [],
  menuItems: [],
  tabletitle: "",
  gridid: "",
};

export default ViewDataGridProduct;
